import React, { Component } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../NavBar";
import Footer from "../Footer";
import { motion } from "framer-motion";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import "./index.css";

class FaqItem extends Component {
  state = { isOpen: false };

  toggleOpen = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { question, answer } = this.props;
    const { isOpen } = this.state;

    return (
      <div className="faq-item">
        <button className="faq-button" onClick={this.toggleOpen}>
          <span className="faq-question">{question}</span>
          {isOpen ? (
            <IoIosArrowUp className="faq-icon" />
          ) : (
            <IoIosArrowDown className="faq-icon" />
          )}
        </button>
        {isOpen && (
          <div className="faq-answer">
            <p className="faq-answer-para">{answer}</p>
          </div>
        )}
      </div>
    );
  }
}

class Faqs extends Component {
  render() {
    const faqs = [
      {
        question: "How much does the trash pickup service cost?",
        answer:
          "$15 per leased unit for standard service. Additional add-ons available, such as a trash and recycling bin combo.",
      },

      {
        question: "What are the trash pickup service contract lengths?",
        answer:
          "We offer a 12-month contract with flexibility to opt out after 6 months",
      },
      {
        question: "How often is trash collected?",
        answer:
          "Monday through Friday service starting at $15 per unit. Also Monday/Wednesday/Friday schedule available at a reduced rate of $5 per unit.",
      },
      {
        question: "Are employees screened?",
        answer:
          "Yes, all our subcontractors undergo thorough background checks and are carefully selected for reliability and professionalism.",
      },
      {
        question: "What happens with vacant units?",
        answer:
          "You only pay for leased units - there's no charge for vacant apartments.",
      },

      {
        question: "How do I get started?",
        answer:
          "Simply click the Contact Us button or fill out our contact form. We'll get back to you within 24 hours to discuss your specific needs.",
      },
    ];

    return (
      <>
        <Helmet>
          <title>
            FAQs | Trusted Apartment Trash Collection Services in Peoria, IL
          </title>
          <meta
            name="description"
            content="Keep your apartment complex clean with our professional apartment trash collection services in Peoria, IL, and neighboring cities. Reliable and efficient solutions!"
          />
          <link
            rel="canonical"
            href="https://simpletrashsolutionsllc.com/faqs"
          />
        </Helmet>
        <NavBar />
        <div className="faqs-container min-h-screen bg-gray-50 py-16">
          <div className="faqs-content max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="faqs-header text-center mb-12"
            >
              <h1 className="faqs-title">Frequently Asked Questions</h1>
              <p className="faqs-description">
                Find answers to common questions about our apartment trash
                collection services, including door-to-door trash pickup and
                affordable trash removal. We’re here to make trash management
                easy and hassle-free for you.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="faqs-list bg-white rounded-lg shadow-lg p-6"
            >
              {faqs.map((faq, index) => (
                <FaqItem
                  key={index}
                  question={faq.question}
                  answer={faq.answer}
                />
              ))}
            </motion.div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Faqs;
